<template>
  <div class="sample-push h-full relative" v-loading="loading">
    <ItemContainer :ref="'ItemContainer' + (index + 1)" :title="`第 ${index + 1} 次样本库推送`">
      <!-- 未推送部分 -->
      <div class="precise-push flex h-full overflow-hidden" v-if="isShow">
        <div class="precise-push-box">
          <div>
            <div class="text-medium leading-22 font-normal pb-2">目标样本属性</div>

            <el-form label-position="left">
              <el-form-item class="solid-line pt checkbox-row" v-for="(val, key, index) in this.toSpread" :key="index">
                <el-col :span="2" class="text-right pr-4 py-4 text-theme-black-650 w-24 font-medium">
                  <span>{{ titleMap[key] }}</span>
                </el-col>
                <el-col :span="21" class="py-4" style="border-bottom: 1px dashed #e7e9eb">
                  <el-checkbox-group v-model="Form[key]" size="small">
                    <el-checkbox-button v-for="(n, i) in val" :label="n.key || n.label" :key="i">{{
                      n.value
                    }}</el-checkbox-button>
                  </el-checkbox-group>
                </el-col>
              </el-form-item>
            </el-form>

            <div class="area overflow-hidden solid-line mb-7">
              <el-col :span="2" class="text-right pr-4 pt-4 text-theme-black-650 leading-8 w-24 font-medium">
                <span>地区</span>
              </el-col>
              <el-col :span="21" class="pt-4">
                <el-select v-model="province" multiple filterable placeholder="地区选择">
                  <el-option v-for="item in areaData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-col>
            </div>

            <!-- 推送数量 -->
            <div class="solid-line spread-content overflow-hidden border-solid border-t border-bg-common-color pt-6 ml-1">
              <el-col :span="2" class="mt-2 text-right w-24 pr-4 leading-22 box-border">
                <label>推送数量</label>
              </el-col>
              <el-col :span="21">
                <el-popover placement="top-start" width="345" trigger="manual" v-model="popoverVisible">
                  <div class="popper-container">
                    <span>友情提示</span>
                    <div class="flex justify-between">
                      <p>已超过您个人免费额度（{{ availableQuantity }}）剩余值</p>
                      <p class="text-theme cursor-pointer" @click="joinActivity">参与活动领样本配额</p>
                    </div>
                  </div>
                  <div slot="reference" class="flex items-center">
                    <el-input-number
                      :min="1"
                      controls-position="right"
                      class="text-center demand-count"
                      v-model="spreadNumber"
                      placeholder="请输入"
                      @blur="spreadNumberChange"
                    ></el-input-number>
                    <div style="line-height: 38px; width: 600px" class="flex text-theme-black-650 ml-2">
                      (剩余{{ availableQuantity }}个，如需更多额度，请
                      <el-popover placement="top-start" trigger="hover">
                        <div style="width: 200px; height: 200px">
                          <img src="/assets/img/code/Mrs.Chai.png" class="w-full h-full" />
                        </div>
                        <div class="weixin text-theme cursor-pointer" slot="reference">联系我们</div>
                      </el-popover>
                      )
                    </div>
                  </div>
                </el-popover>
              </el-col>
            </div>

            <!-- 提示文字 -->
            <div class="leading-24 text-medium bg-card-bg-gray mt-3 mx-1 mb-6 px-4 py-3 text-theme-black-650">
              <p class="text-theme-black-850">注意事项：</p>
              <p class="flex">
                <span>1.</span>
                <span>
                  通过样本库发布，系统会将您的{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}精准推送给目标样本，但无法保证回收率。为了提高回收率和答题者的积极性，需要您为{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}添加红包。（问题数量20题以内：0.5-1元；21-40题：1-3元；41-60题：4-9元；61题以上：10元以上），微信红包由答题人领取，<span v-custom="'out_D74'">调研工厂</span>不收取任何费用。
                </span>
              </p>
              <p>2. 通过样本库发布的{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}请勿设置答题密码。</p>
              <p>
                3. 如需指定配额推送，请
                <el-popover placement="top-start" trigger="click">
                  <div style="width: 200px; height: 200px">
                    <img src="/assets/img/code/Mrs.Chai.png" class="w-full h-full" />
                  </div>
                  <div class="weixin text-theme cursor-pointer inline-block" slot="reference">咨询客服</div>
                </el-popover>
              </p>
            </div>

            <el-popover :disabled="isPopoverDisabledCpd" placement="bottom" trigger="hover">
              <div v-if="surveyStatus === $getConst('NO_PUBLISH')">
                请先<span class="publish_text" @click="publishSurveyFun">发布</span>{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}
              </div>
              <div v-else-if="surveyStatus === $getConst('NO_PUBLISH_AUDIT') || surveyStatus === $getConst('PUBLISHING_AUDIT')">
                {{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}审核中，无法使用本功能
              </div>
              <div v-else-if="surveyStatus === $getConst('NO_PUBLISH_REJECT') || surveyStatus === $getConst('PUBLISHING_REJECT')">
                {{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}审核拒绝，无法使用本功能
              </div>
              <div v-else-if="surveyStatus === $getConst('CLOSE')">{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}停止回收，无法使用本功能</div>
              <div v-else-if="surveyStatus === $getConst('TASK_DOWN')">{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}已下架，无法使用本功能</div>

              <span slot="reference">
                <el-button
                  type="primary"
                  :disabled="isDisabledBtnCpd"
                  size="small"
                  @click="postForm"
                  class="ml-1 mb-6 normal-button"
                >
                  推 送
                </el-button>
              </span>
            </el-popover>
          </div>
        </div>

        <!-- 未添加微信红包的提示 -->
        <el-dialog title="提示" :visible.sync="redEnvelopesVisible" width="30%" :before-close="handleClose">
          <span class="leading-24" v-if="envelopesFlag">
            通过样本库发布的{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}请先添加微信红包（问题数量20题以内：0.5-1元；21-40题：1-3元；41-60题：4-9元；61题以上：10元以上），微信红包由答题人领取，调研工厂不收取任何费用
          </span>
          <span slot="footer" class="dialog-footer" v-if="envelopesFlag">
            <el-button size="small" @click="handleClose">放弃发布</el-button>
            <el-button size="small" type="primary" @click="goRedEnvelopes">添加红包</el-button>
          </span>
          <div class="leading-24" v-if="push3XFlag">
            <div>样本库推送数量不能超过待发放红包数量的 3 倍</div>
            <div>当前待发放红包：{{ redEnvelopesNum }} 个</div>
            <div>本次最多可推送：{{ 3 * redEnvelopesNum }} 个</div>
            <div>请修改样本库推送数量后，重新发起推送</div>
          </div>
          <span slot="footer" class="dialog-footer" v-if="push3XFlag">
            <el-button size="small" type="primary" @click="handleClose">我知道了</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 已推送部分 -->
      <already-push
        :data="pushedData"
        ref="already"
        :id="id"
        :shoBtn="shoBtn"
        :SurveySampleCondition="SurveySampleCondition"
        @changeShow="changeShow"
        :getData="getData"
        @hiddenAddBtn="hiddenAddBtn"
        @changeRePushFlag="changeRePushFlag"
        v-else
      />
    </ItemContainer>
    <sensitiveDialog :sensitiveShow="sensitiveShow" :sensitiveData="sensitiveData" @onCloseDialog="sensitiveShow = false" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getSurveySampleCondition, sendSampleForm, getSampleData, getById } from '@/api/wenjuan/quota.js'
import GlobalConfig from '@/global/config.js'
import AlreadyPush from './AlreadyPush.vue'
import ItemContainer from '@/components/base/ItemContainer.vue'
import sensitiveDialog from '@/components/dialog/sensitiveDialog'
import { publishWJMixins } from '@/mixins/publish'
import { toSurveyBaseNew } from '@/assets/js/base-platform.js'

export default {
  name: 'SamplePush',
  components: { AlreadyPush, ItemContainer, sensitiveDialog },
  mixins: [publishWJMixins],
  props: {
    id: {
      type: String,
      default: ''
    },
    selData: Object,
    showBtn: Function,
    hiddenBtn: Function,
    getData: Function,
    shoBtn: Boolean,
    SurveySampleCondition: Object,
    trueGetCheckData: Function,
    getCheckData: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      redEnvelopesVisible: false,
      envelopesFlag: false,
      push3XFlag: false,
      redEnvelopesNum: 0,
      isShow: false,
      rePushFlag: false, // 是否进行重新推送的开关
      // 传给已经推送模块的数据
      pushedData: {},
      loading: true,
      titleMap: {
        ages: '年龄段',
        areas: '地区',
        educations: '学历',
        genders: '性别',
        incomes: '月收入状况',
        industries: '行业',
        professions: '职业',
        relations: '婚姻状况'
      },
      availableQuantity: 0,
      spreadNumber: undefined,
      // 遍历上面记录的菜单 然后把菜单数据加进来
      toSpread: {},
      // 记录表单的数据
      Form: {
        ages: [],
        educations: [],
        genders: [],
        incomes: [],
        industries: [],
        professions: [],
        relations: []
      },
      popoverVisible: false,
      data: {},
      // 最终提交的表单数据
      finalForm: {},
      // 获取回来的地区数据 级联选择器用的数据
      areaData: [],
      // 存放点击的地区数据 最后拼接一下给接口返回
      province: [],
      sensitiveData: {},
      sensitiveShow: false
    }
  },
  created() {
    this.loading = true
    this.init()
  },
  computed: {
    ...mapState({
      surveyStatus: state => state.survey.surveyStatus,
      isRecycle: state => state.survey.isRecycle
    }),
    ...mapGetters(['questionList']),
    isQs() {
      return this.questionList.length > 0
    },
    isDisabledBtnCpd() {
      if (this.isRecycle) {
        return false
      }
      return true
    },
    isPopoverDisabledCpd() {
      return (
        this.isRecycle ||
        this.surveyStatus === this.$getConst('PUBLISH_UPDATE') ||
        this.surveyStatus === this.$getConst('PUBLISHING_AUDIT_SUCCESS')
      )
    }
  },
  methods: {
    // 跳转落地页活动页面
    joinActivity() {
      toSurveyBaseNew('/sample-library-push', { returns: 'trues' })
    },
    handleClose() {
      this.redEnvelopesVisible = false
      this.envelopesFlag = false
      this.push3XFlag = false
    },
    publishSurveyFun() {
      if (!this.isQs) {
        this.$message.warning('先去添加问题，再来发布问卷吧！')
        return
      }
      this.publishQuestion(GlobalConfig.getSurveyId()).catch(e => {
        // 为防止其他操作没有敏感词的 弹敏感词弹窗
        if (!e) return
        this.sensitiveData = e
        this.sensitiveShow = true
      })
    },
    // 重新编辑按钮调用的方法
    changeShow() {
      this.isShow = !this.isShow
    },
    hiddenAddBtn() {
      this.$emit('hiddenBtn')
    },
    // 调整重新推送开关的状态 - 以判断是重新推送还是新建的推送
    changeRePushFlag() {
      this.rePushFlag = !this.rePushFlag
    },
    // 进行数量比较，弹出提示
    spreadNumberChange() {
      if (this.availableQuantity < this.spreadNumber) {
        this.popoverVisible = true
        setTimeout(() => {
          this.popoverVisible = false
        }, 3000)
        return false
      } else if (!this.spreadNumber) {
        this.$message.error('请输入推送数量')
      } else {
        return true
      }
    },
    // 获取勾选多选框的数据
    getSelectData() {
      this.loading = true
      let data = {}
      if (this.selData !== null) {
        data = JSON.parse(this.selData.screeningCondition)
      }
      this.isShow = this.selData === null
      if (this.getCheckData) {
        // 如果getCheckData为true，才会获取checkbox的数据，进入已推送界面
        if (!this.isShow) {
          this.$emit('showBtn')
        }

        // 给form每个选项赋值
        if (data !== null) {
          Object.keys(data).forEach(item => {
            if (data[item] instanceof Array) {
              this.Form[item] = data[item]
            }
          })
          // 地区的数据单独处理
          if (data['areas'] instanceof Array) {
            this.province = data['areas']
          }
        }

        // 二次处理 - 把form的每个都换成字符串
        for (let key in this.Form) {
          if (Array.isArray(this.Form[key])) {
            this.Form[key] = this.Form[key].map(item => {
              return item + ''
            })
          } else if (this.Form[key] == null) {
            this.Form[key] = []
          }
        }
      } else {
        // 如果getCheckData为false，就不会获取checkbox的数据，直接进入样本库推送的选择界面
        this.isShow = true
      }
      this.pushedData = this.selData
      this.loading = false
    },
    async init() {
      if (this.id && this.id !== '0') {
        this.getSelectData()
        this.loading = true
      } else {
        // 如果没有该项目的id，直接进入样本库推送的选择界面
        this.isShow = true
      }
      this.loading = true
      // 获取多选框数据
      let data = JSON.parse(JSON.stringify(this.SurveySampleCondition))

      this.availableQuantity = data.availableQuantity
      delete data.availableQuantity
      let temData = {}
      for (let key in data) {
        // 单独处理地区的数据 因为地区是一个下拉选择题
        if (key == 'areas') {
          this.areaData = data[key]
          continue
        }
        temData[key] = data[key].slice(1)
      }
      this.data = temData
      this.toSpread = this.data
      this.loading = false
    },
    // 点击确定提交表单做的操作
    postForm() {
      if (!this.spreadNumberChange()) {
        return
      }

      let formData = JSON.parse(JSON.stringify(this.Form))
      formData.industrys = formData.industries
      delete formData.industries
      formData.areas = this.province
      this.finalForm = {
        surveyId: GlobalConfig.getSurveyId(),
        quantity: parseInt(this.spreadNumber),
        condition: formData
      }
      // 如果重新推送的开关为true，在上传的参数里添加这个任务的id
      if (this.rePushFlag) {
        this.finalForm.sampleSendId = this.id
      }

      sendSampleForm(this.finalForm).then(res => {
        if (res.status === 200 && res.data.code === 0) {
          // 推送成功以后，立刻将GetCheckData字段改成true，不给其他的操作添麻烦
          this.$emit('trueGetCheckData')
          this.$message({
            message: '推送样本成功',
            type: 'success'
          })
          // 推送成功，显示增加推送的按钮
          this.$emit('showBtn')
          this.$emit('getData')
          this.getSelectData()
        } else if (res.data.code === 1 && res.data.msg === '红包金额小于0.5元') {
          // 校验红包金额是否正确
          this.$message.error('单个微信红包必须大于0.5元才可使用样本库推送')
        } else if (res.data.code === 1 && res.data.msg === '该问卷没有携带红包') {
          // 校验问卷是否推送红包
          this.redEnvelopesVisible = true
          this.envelopesFlag = true
        } else if (res.data.code === 1 && res.data.msg.includes('推送红包数量大于待发布红包数量的3倍')) {
          // 校验问卷是否多余三倍推送红包
          let number = res.data.msg.split(',')[1]
          this.redEnvelopesNum = number.split(':')[1]
          this.redEnvelopesVisible = true
          this.push3XFlag = true
        } else {
          this.$message.error(res.data.msg || '推送样本失败')
        }
      })
    },
    goRedEnvelopes() {
      this.$router.push({ 
        name: 'red-envelopes',
        query: {
          scene: this.$route.query.scene
        }
      })
    }
  },
  // 解决复选框单边框问题
  mounted() {
    try {
      const rows = document.getElementsByClassName('el-form-item__content')
      for (let i = 0; i < rows.length; i++) {
        if (rows[i].innerText.includes('职业')) {
          let cell = []
          cell.push(rows[i].children[1].children[0].children[4].children[1])
          cell.push(rows[i].children[1].children[0].children[6].children[1])
          cell.push(rows[i].children[1].children[0].children[11].children[1])
          cell.forEach(item => {
            item.style.borderLeft = '1px solid #d8d8d8'
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  @apply p-0 h-full;
}

::v-deep .el-checkbox-button__inner {
  @apply text-theme-black-650 font-medium;
  border-radius: 0 !important;
}
::v-deep .el-checkbox-button {
  @apply py-1;
}

::v-deep .el-checkbox-group {
  .el-checkbox-button__inner {
    border: 1px solid #d8d8d8;
    @apply border-l-0;
  }
  .el-checkbox-button:nth-child(1) {
    .el-checkbox-button__inner {
      @apply border-l;
    }
  }
  .is-checked {
    .el-checkbox-button__inner {
      @apply bg-theme bg-opacity-10 border border-theme border-solid text-theme border-l-0;
    }
  }
  .is-checked:nth-child(1) {
    .el-checkbox-button__inner {
      @apply border-l;
    }
  }
}

.title::before {
  content: '';
  @apply bg-theme block float-left w-1 h-5 -ml-6;
}
.el-form-item {
  @apply mb-0;
}
::v-deep .el-scrollbar__view {
  @apply h-full overflow-auto;
}
::v-deep .sample-push {
  .el-dialog__wrapper {
    position: absolute;
  }
  .v-modal {
    position: absolute;
  }
}
</style>
<style lang="scss">
.demand-count {
  .el-input__inner {
    border-color: #dcdfe6;
    @apply bg-white border border-solid;
  }
}
.publish_text {
  cursor: pointer;
  @apply text-theme;
}
</style>
